'use client'

import { ReactNode } from 'react'

import { Offline } from 'shared/ui/offline/Offline'

import useNetwork from 'shared/hooks/useNetwork/useNetwork'

interface NetworkLayoutProps {
  children: ReactNode
}

export const NetworkLayout = ({ children }: NetworkLayoutProps) => {
  const isOnline = useNetwork()

  if (!isOnline) {
    return <Offline />
  }
  return children
}
